import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../Navigation";
import { RegDiv } from "../../Components";
import "../../index.css";
import {
  getLanguage,
  setLanguage,
  subscribeLanguage,
} from "../../global/language";

export default function TennisMasterApp() {
  const [showModal, setShowModal] = useState(false);
  const [language, updateLanguage] = useState(getLanguage());

  useEffect(() => {
    return subscribeLanguage((lang) => {
      updateLanguage(lang);
    });
  }, []);
  const text = {
    en: {
      heroTitle: "Tennis Master - Your AI Tennis Coach Anywhere, Anytime",
      heroDesc:
        "Analyze your swing with advanced AI, get instant coaching tips, and improve your technique faster than ever before.",
      download: "Download App",
      getApp: "Get the App",
      about: "About Tennis Master",
      aboutDesc:
        "Tennis Master is the next evolution of tennis coaching — built with AI-powered video analysis, smart technical breakdowns, and player matchmaking tools.",
      aboutDesc1:
        "Using advanced AI swing analysis, players can receive instant feedback on forehands, backhands, serves, and volleys, while learning proper techniques and tracking long-term progress.",

        downloadTitle: "Download Tennis Master",
      iphone: "iPhone / iPad",
      android: "Android APK",
      appStore: "Download on App Store",
      apk: "Download APK",
      howItWorks: "How It Works",
      easy: "1. Easy to use",
      easyguide:"Just video your strokes, such as forehand, backhand, volley and serve, then upload to do analysis.",
      ai: "2. AI Analysis",
      aievaluate:"Just video your strokes, such as forehand, backhand, volley and serve, then upload to do analysis.",
      feedback: "3. Coaching Feedback",
      fdcontent:"Instant visual overlays, biomechanical breakdowns, and improvement tips.",
      key:"Key Features",
      accuanalysis:"Accurate AI Swing Analysis",
      tracking:"Long-Term Progress Tracking",
      slowmotion:"Slow Motion For Clearer Feedback",
      inapp:"In-App Training Library",
      instantfeed:"Instant Feedback & Corrections",
      anydevice:"Works on Any Device",
      whychoose:"Why Choose Tennis Master?",
      improve: "Improve faster with error detection",
      train:"Train like the pros with AI biomechanics",
      pratice:"Practice anywhere, anytime",
      avoid:"Avoid costly coaching sessions",
      start:"Start Training with Tennis Master",
      inpocket:"Your personal AI tennis coach — in your pocket."
    },

    zh: {
      heroTitle: "网球大师 - 您的 AI 网球教练, 随时随地",
      heroDesc:
        "通过先进 AI 分析您的挥拍动作，获得即时指导建议，更快提升网球技术。",
      download: "下载应用",
      getApp: "立即下载",
      about: "关于 AI 网球大师",
      aboutDesc:
        "AI 网球大师 是新一代 AI 网球训练平台，提供视频分析、技术动作拆解以及球员匹配功能。",
      aboutDesc1:
        "通过先进的 AI 挥拍分析，球员可以获得正手、反手、发球和截击等动作的即时反馈，学习正确技术，并长期追踪训练进步。",
        downloadTitle: "下载 AI 网球大师",
      iphone: "苹果 iPhone / iPad",
      android: "安卓 APK",
      appStore: "App Store 下载",
      apk: "下载 APK",
      howItWorks: "工作原理",
      easy: "1. 简单易用",
      ai: "2. AI 分析",
      feedback: "3. 教练反馈",
      easyguide: "只需录制您的击球动作，例如正手、反手、截击和发球，然后上传进行分析。",
      aievaluate: "我们的 AI 模型会评估身体旋转、姿势、手腕角度、挥拍路径、击球时机等多项技术细节。",
      fdcontent: "即时动作可视化、运动生物力学分析，以及个性化提升建议。",
      key: "核心功能",
      accuanalysis: "精准 AI 挥拍分析",
      tracking: "长期训练进度追踪",
      slowmotion: "慢动作回放，反馈更清晰",
      inapp: "应用内训练课程库",
      instantfeed: "即时反馈与动作纠正",
      anydevice: "支持所有设备使用",
      whychoose: "为什么选择 Tennis Master？",
      improve: "通过错误检测更快提升水平",
      train: "借助 AI 生物力学训练，像职业选手一样训练",
      pratice: "随时随地进行练习",
      avoid: "节省高昂的教练费用",
      start: "开始使用 Tennis Master 训练",
      inpocket: "您的专属 AI 网球教练，随身携带。"
    },
  };
  const t = text[language];
  return (
    <div className="font-sans bg-gray-50 text-gray-900">
      {/* SEO */}
      <Helmet>
        <title>Tennis Master – AI Tennis Video Analysis App</title>
        <meta
          name="description"
          content="Tennis Master is an AI-powered tennis video analysis app that helps players improve form, technique, and performance with instant feedback."
        />
        <meta
          name="keywords"
          content="Tennis app, AI tennis analysis, tennis coaching, video analysis, tennis technique, forehand analysis, tennis improvement"
        />
        <meta name="author" content="Tennis Master" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      {/* Navbar */}
      <RegDiv>
        <RegDiv height="2vw"></RegDiv>
        <Navbar language={language} />
        <div className="flex justify-end px-6 mt-4">
            <button
              onClick={() =>
                setLanguage(language === "en" ? "zh" : "en")
              }
              className="px-4 py-2 bg-green-700 text-white rounded-lg shadow hover:bg-green-800 transition"
            >
              {language === "en" ? "中文" : "English"}
            </button>
        </div>
        
      </RegDiv>

      {/* HERO SECTION */}
      <section className="w-full py-20 bg-green-700 text-white text-center px-6 bg-[url('/images/tennis-court-bg.jpg')] bg-cover bg-center">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 drop-shadow-lg">
          {t.heroTitle}
        </h1>

        <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 opacity-90">
          {t.heroDesc}
        </p>

        <div className="flex justify-center gap-4 mt-6 flex-wrap">
          <button
            onClick={() => setShowModal(true)}
            className="px-6 py-3 bg-yellow-400 text-black rounded-xl font-semibold shadow hover:scale-105 transition"
          >
            {t.download}
          </button>

          {/* <button className="px-6 py-3 bg-white text-green-700 rounded-xl font-semibold shadow hover:scale-105 transition">
            Try Web Demo
          </button> */}
        </div>
      </section>

      {/* DOWNLOAD MODAL */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 overflow-y-auto">          
          <div
            className="
              bg-white rounded-2xl p-6
              max-w-3xl w-full
              max-h-[85vh]
              overflow-y-auto
              overscroll-contain
              relative shadow-2xl
              touch-pan-y
            "
          >            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl"
            >
              ×
            </button>

            <h2 className="text-3xl font-bold text-center text-green-700 mb-8">
              {t.downloadTitle}
            </h2>

            <div className="grid md:grid-cols-2 gap-10">
              
              {/* Apple Store */}
              <div className="text-center border rounded-xl p-6 shadow-sm">
                <h3 className="text-2xl font-semibold mb-4 text-gray-800">
                  {t.iphone}
                </h3>

                {/* Apple QR */}
                <img
                  src="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=https://apps.apple.com/us/app/tennis-master-ai-tennis-coach/id6755618827"
                  alt="Apple Store QR Code"
                  className="mx-auto mb-4"
                />

                <a
                  href="https://apps.apple.com/us/app/tennis-master-ai-tennis-coach/id6755618827"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block mt-2 px-5 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition"
                >
                  {t.appStore}
                </a>
              </div>

              {/* Android APK */}
              <div className="text-center border rounded-xl p-6 shadow-sm">
                <h3 className="text-2xl font-semibold mb-4 text-gray-800">
                  {t.android}
                </h3>

                {/* Android QR */}
                <img
                  src="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=https://drive.google.com/file/d/15Koz-glNLILMBAM4q261YR96pS1z4q0f/view?usp=sharing"
                  alt="Android APK QR Code"
                  className="mx-auto mb-4"
                />

                <a
                  href="https://drive.google.com/file/d/15Koz-glNLILMBAM4q261YR96pS1z4q0f/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block mt-2 px-5 py-3 bg-green-700 text-white rounded-lg hover:bg-green-800 transition"
                >
                  {t.apk}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ABOUT SECTION */}
      <section className="max-w-4xl mx-auto py-16 px-6">
        <h2 className="text-3xl font-bold text-green-800 mb-4">
          {t.about}
        </h2>

        <p className="text-lg leading-relaxed">
          {t.aboutDesc}   <br></br>   <br></br>
          {t.aboutDesc1}     
        </p>
      </section>

      {/* HOW IT WORKS */}
      <section className="bg-white py-16 border-t">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-green-800 mb-10">
            {t.howItWorks}
          </h2>

          <div className="grid md:grid-cols-3 gap-10">
            <div className="text-center">
              <h3 className="text-xl font-semibold mb-2">{t.easy}</h3>
              <p>
                {t.easyguide}
              </p>
            </div>

            <div className="text-center">
              <h3 className="text-xl font-semibold mb-2">{t.ai}</h3>
              <p>
               {t.aievaluate}
              </p>
            </div>

            <div className="text-center">
              <h3 className="text-xl font-semibold mb-2">
                {t.feedback}
              </h3>
              <p>
                {t.fdcontent}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* KEY FEATURES */}
      <section className="max-w-5xl mx-auto py-16 px-6">
        <h2 className="text-3xl font-bold text-green-800 mb-8">
          {t.key}
        </h2>

        <ul className="grid md:grid-cols-2 gap-8 text-lg">
          <li>🎯 {t.accuanalysis}</li>
          <li>📊 {t.tracking}</li>
          <li>🎥 {t.slowmotion}</li>
          <li>🧠 {t.inapp}</li>
          <li>⚡ {t.instantfeed}</li>
          <li>📱 {t.anydevice}</li>
        </ul>
      </section>

      {/* WHY CHOOSE */}
      <section className="bg-green-50 py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-green-800 mb-6">
            {t.whychoose}
          </h2>

          <ul className="list-disc pl-6 text-lg space-y-2">
            <li>🚀 {t.improve}</li>
            <li>🎾 {t.train}</li>
            <li>📱 {t.pratice}</li>
            <li>💰 {t.avoid}</li>
          </ul>
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="text-center py-20 bg-green-700 text-white">
        <h2 className="text-3xl font-bold mb-4">
          {t.start}
        </h2>

        <p className="text-lg mb-6">
          {t.inpocket}
        </p>

        <button
          onClick={() => setShowModal(true)}
          className="px-6 py-3 bg-yellow-400 text-black rounded-xl font-semibold shadow hover:scale-105 transition"
        >
          {t.getApp}
        </button>
      </section>
    </div>
  );
}